import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "aspectRatio",
        "originX",
        "originY",
        "sizeWidth",
        "sizeHeight",
        "sizeAspectRatioX",
        "sizeAspectRatioY"
    ];

    connect() {
        this.initCropper();
        if (isNaN(this.aspectRatio)) {
            this.sizeAspectRatioX = NaN;
            this.sizeAspectRatioY = NaN;
        }
    }

    get scaleFactor() {
        return this.data.get('scaleFactor')
    }

    get imageSizeWidth() {
        return this.data.get('imageSizeWidth')
    }

    get imageSizeHeight() {
        return this.data.get('imageSizeHeight')
    }

    get previewSizeWidth() {
        return this.data.get('previewSizeWidth')
    }

    get previewSizeHeight() {
        return this.data.get('previewSizeHeight')
    }

    get aspectRatio() {
        const aspectRatioValues = this.aspectRatioTarget.value.match(/(\d+):(\d+)/);

        if (aspectRatioValues) {
            const x = aspectRatioValues[1];
            const y = aspectRatioValues[2];

            return x / y;
        }

        return NaN;
    }

    get originX() {
        return parseInt(this.originXTarget.value, 10);
    }

    set originX(originX) {

        this.originXTarget.value = originX;
    }

    get originY() {
        return parseInt(this.originYTarget.value, 10);
    }

    set originY(originY) {
        this.originYTarget.value = originY;
    }

    get sizeWidth() {
        return parseInt(this.sizeWidthTarget.value, 10);
    }

    set sizeWidth(sizeWidth) {
        this.sizeWidthTarget.value = sizeWidth;
    }

    get sizeHeight() {
        return parseInt(this.sizeHeightTarget.value, 10);
    }

    set sizeHeight(sizeHeight) {
        this.sizeHeightTarget.value = sizeHeight;
    }

    set sizeAspectRatioX(sizeAspectRatioX) {
        this.sizeAspectRatioXTarget.value = sizeAspectRatioX;
    }

    set sizeAspectRatioY(sizeAspectRatioY) {
        this.sizeAspectRatioYTarget.value = sizeAspectRatioY;
    }

    initCropper() {
        const image = document.getElementById('image');

        // Calcul des coordonnées de crop à l'échelle de la vignette
        let x = Math.floor(this.originX / this.scaleFactor);
        let y = Math.floor(this.originY / this.scaleFactor);
        let width = Math.round(this.sizeWidth / this.scaleFactor);
        let height = Math.round(this.sizeHeight / this.scaleFactor);

        // Ajustement si l'on dépasse à cause des problèmes d'arrondi
        if (width > this.previewSizeWidth) {
            width = this.previewSizeWidth;
        }
        if (x + width > this.previewSizeWidth) {
            x = this.previewSizeWidth - width;
        }

        if (height > this.previewSizeHeight) {
            height = this.previewSizeHeight;
        }
        if (y + height > this.previewSizeHeight) {
            y = this.previewSizeHeight - height;
        }

        this.cropper = new Cropper(image, {
            aspectRatio: this.aspectRatio,
            autoCropArea: 1,
            viewMode: 3,
            modal: true,
            movable: false,
            zoomable: false,
            rotatable: false,
            scalable: false,
            data: {x: x, y: y, width: width, height: height},
            crop: (event) => {
                // Calcul des coordonnées de crop à l'échelle de l'image
                let x = Math.floor(event.detail.x * this.scaleFactor);
                let y = Math.floor(event.detail.y * this.scaleFactor);
                let width = Math.round(event.detail.width * this.scaleFactor);
                let height = Math.round(event.detail.height * this.scaleFactor);

                if (width > this.imageSizeWidth) {
                    width = this.imageSizeWidth;
                }
                if (x + width > this.imageSizeWidth) {
                    x = this.imageSizeWidth - width;
                }

                if (height > this.imageSizeHeight) {
                    height = this.imageSizeHeight;
                }
                if (y + height > this.imageSizeHeight) {
                    y = this.imageSizeHeight - height;
                }

                this.originX = x;
                this.originY = y;
                this.sizeWidth = width;
                this.sizeHeight = height;
            }
        });
    }

    refreshAspectRatio() {
        const aspectRatioValues = this.aspectRatioTarget.value.match(/(\d+):(\d+)/);
        const x = aspectRatioValues ? aspectRatioValues[1] : NaN;
        const y = aspectRatioValues ? aspectRatioValues[2] : NaN;
        const aspectRatio = x / y;

        this.sizeAspectRatioX = x;
        this.sizeAspectRatioY = y;
        this.cropper.setAspectRatio(aspectRatio);
        if (isNaN(aspectRatio)) {
            const width = this.previewSizeWidth * 0.8;
            const height = this.previewSizeHeight * 0.8;
            this.cropper.setCropBoxData({
                left: (this.previewSizeWidth - width) / 2,
                top: (this.previewSizeHeight - height) / 2,
                width: width,
                height: height
            });
        }
    }
}
